// extracted by mini-css-extract-plugin
export default {"ListCard":"ListCard_ListCard__EIPKM"};